export const offersWidgetFrameParams = { async: true, mode: 1, useslider: 1 }
